import styled from "styled-components";
import { Flex, Typography } from "antd";

// ─── Chart Header ─────────────────────────────────────────────────────────────
// Needs text-align + padding — no AntD component maps to these as props.

export const ChartHeaderStyled = styled.div`
  text-align: center;
  padding: 8px 0 4px;
`;

export const ChartTitleStyled = styled(Typography.Title)`
  && {
    font-size: 18px;
    margin-bottom: 4px;
  }
`;

export const ChartSubtitleStyled = styled(Typography.Text)`
  && {
    font-size: 12px;
  }
`;

// ─── Bubble Chart Wrapper ─────────────────────────────────────────────────────
// styled(Flex): Flex handles vertical + align="center"; styled adds border + padding.

export const BubbleChartWrapperStyled = styled(Flex)`
  border: 1px solid ${(p) => p.theme?.colors?.border ?? "#D8DAE5"};
  border-radius: 8px;
  padding: 20px 16px 12px;
`;

export const SkillsDetectedStyled = styled(Typography.Text)`
  && {
    font-size: 13px;
    align-self: flex-start;
    margin-top: 10px;
  }
`;

// ─── Footnotes ────────────────────────────────────────────────────────────────

export const FootnoteTextStyled = styled(Typography.Text)`
  && {
    font-size: 12px;
    display: block;
  }
`;
